export default __webpack_public_path__ + "static/media/IMG12.1c925778.png";